import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private readonly _isVisible = new BehaviorSubject<boolean>(false);
  public readonly isVisible$ = this._isVisible.asObservable();

  private _counter = 0; // contador para solicitudes paralelas

  public show(): void {
    this._counter++;
    this._isVisible.next(true);
  }

  public hide(force = false): void {
    if (force) {
      this._counter = 0;
    } else {
      this._counter = Math.max(0, this._counter - 1);
    }

    if (this._counter === 0) {
      this._isVisible.next(false);
    }
  }

  public reset(): void {
    this._counter = 0;
    this._isVisible.next(false);
  }
}
